module.exports = __webpack_public_path__ + "img/9.e1ea62b5.png";